import ctl from '@netlify/classnames-template-literals';

export const classes = {
  row: ctl(`
    border-t-chinese-silver 
    border-t-[1px] 
    text-sm hover:bg-ghost-white 
    transition-colors
    cursor-pointer
  `),
  cell: 'offset-base',
  menuContainer: 'pt-[6px]',
  tbodyColor: 'bg-white',
  menuColor: 'text-waterspout',
};
